import omit from 'lodash/omit'

import { DELETE_MESSAGE_SUCCESS } from '../actions/messages'

export default function (state = {}, action) {
  switch (action.type) {
    case DELETE_MESSAGE_SUCCESS:
      return omit(state, action.payload.resourceId)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/messages.js